import { Check, Play, RotateCcw } from "lucide-react";
import { useState } from "react";

const traceSteps = [
  { label: "Browser", detail: "GET /api/graph", metric: "0 ms" },
  { label: "Validation", detail: "Query contract", metric: "<1 ms" },
  { label: "Worker", detail: "Graph service", metric: "3 ms" },
  { label: "D1", detail: "8 typed queries", metric: "12 ms" },
  { label: "Response", detail: "GraphSnapshot", metric: "18 ms" },
];

export function TypeLab() {
  const [density, setDensity] = useState(54);
  const [contrast, setContrast] = useState<"paper" | "signal">("paper");
  return (
    <article className="lab-experiment type-lab">
      <header><span>001</span><div><p className="eyebrow">TYPOGRAPHY / DENSITY</p><h2>Information rhythm under pressure.</h2></div><strong>BUILT</strong></header>
      <div className="lab-grid">
        <div className={`type-specimen ${contrast}`} style={{ "--lab-density": `${density}px` } as React.CSSProperties}>
          <span className="specimen-label">SYSTEM POSITION / 04</span>
          <h3>Typed boundaries reduce invisible disagreement.</h3>
          <p>Browser state crosses HTTP, runtime validation, service logic and relational persistence. Each boundary makes a different failure legible.</p>
          <div className="specimen-data"><span>API</span><strong>18 ms</strong><span>D1</span><strong>12 ms</strong><span>STATE</span><strong>SHIPPED</strong></div>
        </div>
        <div className="lab-controls">
          <label><span>DENSITY</span><input type="range" min="38" max="74" value={density} onChange={(event) => setDensity(Number(event.target.value))} /></label>
          <div className="segmented-control"><button className={contrast === "paper" ? "active" : ""} onClick={() => setContrast("paper")}>PAPER</button><button className={contrast === "signal" ? "active" : ""} onClick={() => setContrast("signal")}>SIGNAL</button></div>
          <dl><div><dt>Objective</dt><dd>Preserve hierarchy as density changes.</dd></div><div><dt>Promotion gate</dt><dd>Readable at 320 px and 200% zoom.</dd></div><div><dt>Status</dt><dd>Candidate for evidence summaries.</dd></div></dl>
        </div>
      </div>
    </article>
  );
}

export function TraceLab() {
  const [active, setActive] = useState(0);
  return (
    <article className="lab-experiment trace-lab">
      <header><span>002</span><div><p className="eyebrow">REQUEST TRACE / MOTION</p><h2>One interaction across five boundaries.</h2></div><strong>BUILT</strong></header>
      <div className="trace-stage" aria-live="polite">
        {traceSteps.map((step, index) => (
          <div key={step.label} className={index < active ? "complete" : index === active ? "active" : ""}>
            <span>{index < active ? <Check aria-hidden="true" /> : `0${index + 1}`}</span><strong>{step.label}</strong><small>{step.detail}</small><code>{index <= active ? step.metric : "--"}</code>
          </div>
        ))}
      </div>
      <footer>
        <div className="trace-actions"><button className="command-button" onClick={() => setActive((current) => Math.min(traceSteps.length - 1, current + 1))} disabled={active === traceSteps.length - 1}><Play size={15} /> Step trace</button><button className="icon-button" onClick={() => setActive(0)} aria-label="Reset trace"><RotateCcw /></button></div>
        <dl><div><dt>Objective</dt><dd>Expose latency as a sequence, not a spinner.</dd></div><div><dt>Accessibility</dt><dd>Motion-independent state labels.</dd></div><div><dt>Production path</dt><dd>Worker observability timeline.</dd></div></dl>
      </footer>
    </article>
  );
}
